import Vue from 'vue'
import VueRouter from 'vue-router'
import VehicleTradeList from '../views/VehicleTradeList.vue'
import VehicleTradeDetail from '../views/VehicleTradeDetail.vue'
import UserList from '../views/UserList.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/vehicle-trade/list'
  },
  {
    path: '/vehicle-trade/list',
    name: 'VehicleTradeList',
    component: VehicleTradeList,
    meta: { requiresAuth: true }
  },
  {
    path: '/vehicle-trade/detail/:id',
    name: 'VehicleTradeDetail',
    component: VehicleTradeDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/user/list',
    name: 'UserList',
    component: UserList,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  
  if (requiresAuth && !token) {
    // 需要认证但未登录，跳转到登录页
    next('/login')
  } else if (to.path === '/login' && token) {
    // 已登录访问登录页，跳转到首页
    next('/vehicle-trade/list')
  } else {
    next()
  }
})

export default router

